module.exports = __webpack_public_path__ + "../resources/img/ic_sandstorm_weather.546fce99.svg";